define([
    'require',
    'jquery',
    'mainGtm',
    'matchSize'
], (require, $, gtm, matchSize) => {
    return {
        topMenu: undefined,
        gtmArea: '',

        init() {
            if (matchSize().desktop) {
                require(['topMenuDesktop'], topMenuDesktop => {
                    this.topMenu = topMenuDesktop;
                    this.gtmArea = 'header';

                    topMenuDesktop.init();
                });
            } else {
                require(['topMenuMobile'], topMenuMobile => {
                    this.topMenu = topMenuMobile;
                    this.gtmArea = 'burger menu';

                    topMenuMobile.init();
                });
            }

            this.initGtmEvent();
        },

        clearText(text) {
            return text.replace(/\s{2,}/g, '');
        },

        initGtmEvent() {
            $('.menu-nav').on('click', 'a', el => {
                const target = $(el.target);

                //for mobile burger menu trigger only for item without subitems
                if(this.gtmArea === 'burger menu' && target.hasClass('_parent')) {
                    return;
                }

                let label = '';

                for (let i = 3; i >= 0; i--) {
                    const item = $(target.closest(`li.level${i}`));

                    if (item.length) {
                        const name = this.clearText($(item.find('a.gtm-menu-nav-link')[0]).text());

                        label = (label) ? `${name}::${label}` : name;
                    }
                }

                gtm.pushMenuNavigation(this.gtmArea, label);
            });

            /**additional menu item excluded from the rules*/
            $('.header-business-link').on('click', el => {
                gtm.pushMenuNavigation(this.gtmArea, this.clearText(el.target.text));
            });
        },
    };
});
